// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icon_help.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/img_arrow2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/icon_help_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/icon_api_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/icon_api.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/img_arrow1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help {
    background-color: #F4F5F7;
    padding: 0.52083rem 0;
}
.help-wrap {
    width: 7.29167rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.help-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 0.19792rem;
    width: 0.19792rem;
    display: inline-block;
    margin-left: 0.52083rem;
    background-repeat: no-repeat;
    background-size: contain;
}
.help-center:hover {
    transition: all 1s ease;
    background-color: #2475EE;
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.help-center:hover .help-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.help-center:hover .help-text, .help-api:hover .help-text{
    color: #fff;
}
.help-api:hover .api-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.help-api:hover {
    transition: all 1s ease;
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    color: #fff;
    background-color: #2475EE;
}

.api-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 0.19792rem;
    width: 0.19792rem;
    display: inline-block;
    margin-left: 0.52083rem;
    background-repeat: no-repeat;
    background-size: contain;
}
.help-text {
    font-size: 0.16667rem;
    color: #2475EE;
    margin-left: 0.10417rem;
    font-weight: 3.125rem;
}
.help-center, .help-api {
    cursor: pointer;
    width: 3.48958rem;
    height: 0.78125rem;
    display: flex;
    justify-content: left;
    align-items: center;
    background-image:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: center right;
    background-color: #fff;
    background-size: contain;
    background-repeat: no-repeat;
}


@media screen and (max-width: 700px) {
    .api-icon, .help-icon {
        width: 0.35417rem;
        height: 0.35417rem;
    }
    .help-wrap {
        width: 9.375rem;
    }
    .help-center, .help-api {
        width: 4.58333rem;
        height: 1.04167rem;
    }
    .help-text {
        font-size: 0.25rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Help/Help.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAkB;AACtB;AACA;IACI,iBAAa;IACb,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,yDAA0D;IAC1D,kBAAY;IACZ,iBAAW;IACX,qBAAqB;IACrB,uBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,wDAA0D;AAC9D;AACA;IACI,yDAAgE;AACpE;AACA;IACI,WAAW;AACf;AACA;IACI,yDAA+D;AACnE;AACA;IACI,uBAAuB;IACvB,wDAA0D;IAC1D,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yDAAyD;IACzD,kBAAY;IACZ,iBAAW;IACX,qBAAqB;IACrB,uBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,qBAAe;IACf,cAAc;IACd,uBAAiB;IACjB,qBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAY;IACZ,kBAAa;IACb,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,wDAA0D;IAC1D,iCAAiC;IACjC,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;AAChC;;;AAGA;IACI;QACI,iBAAW;QACX,kBAAY;IAChB;IACA;QACI,eAAa;IACjB;IACA;QACI,iBAAY;QACZ,kBAAa;IACjB;IACA;QACI,kBAAe;IACnB;AACJ","sourcesContent":[".help {\n    background-color: #F4F5F7;\n    padding: 100px 0px;\n}\n.help-wrap {\n    width: 1400px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n}\n.help-icon {\n    background-image: url('../../assets/images/icon_help.svg');\n    height: 38px;\n    width: 38px;\n    display: inline-block;\n    margin-left: 100px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.help-center:hover {\n    transition: all 1s ease;\n    background-color: #2475EE;\n    background-image:url('../../assets/images/img_arrow2.png');\n}\n.help-center:hover .help-icon {\n    background-image: url('../../assets/images/icon_help_hover.svg');\n}\n.help-center:hover .help-text, .help-api:hover .help-text{\n    color: #fff;\n}\n.help-api:hover .api-icon {\n    background-image: url('../../assets/images/icon_api_hover.svg');\n}\n.help-api:hover {\n    transition: all 1s ease;\n    background-image:url('../../assets/images/img_arrow2.png');\n    color: #fff;\n    background-color: #2475EE;\n}\n\n.api-icon {\n    background-image: url('../../assets/images/icon_api.svg');\n    height: 38px;\n    width: 38px;\n    display: inline-block;\n    margin-left: 100px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.help-text {\n    font-size: 32px;\n    color: #2475EE;\n    margin-left: 20px;\n    font-weight: 600px;\n}\n.help-center, .help-api {\n    cursor: pointer;\n    width: 670px;\n    height: 150px;\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    background-image:url('../../assets/images/img_arrow1.png');\n    background-position: center right;\n    background-color: #fff;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n\n@media screen and (max-width: 700px) {\n    .api-icon, .help-icon {\n        width: 68px;\n        height: 68px;\n    }\n    .help-wrap {\n        width: 1800px;\n    }\n    .help-center, .help-api {\n        width: 880px;\n        height: 200px;\n    }\n    .help-text {\n        font-size: 48px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
